import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

interface TextBlockProps {
  text: string;
  margin?: number;
  padding?: number;
}

export const StandardTextBlock: React.FC<TextBlockProps> = ({
  text,
  margin,
  padding,
}) => {
  const theme = useTheme();

  return (
    <Box
      my={margin}
      p={padding}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Typography
        variant="body1"
        textAlign="center"
        fontSize={{ xs: "large", md: "large" }}
        color={theme.palette.primary.main}
      >
        {text}
      </Typography>
    </Box>
  );
};
